var map = {
	"./breadcrumb-right.svg": "qv2M",
	"./file-crying-face.svg": "TVLS",
	"./file-folder.svg": "dLDj",
	"./file-home.svg": "Kzi+",
	"./file-list-apk.svg": "/zs7",
	"./file-list-atom.svg": "Fw9U",
	"./file-list-audio.svg": "24h+",
	"./file-list-cd.svg": "KR/S",
	"./file-list-compress.svg": "sFti",
	"./file-list-csh.svg": "Tloy",
	"./file-list-dll.svg": "KAxe",
	"./file-list-docx.svg": "6BtJ",
	"./file-list-exe.svg": "TjOb",
	"./file-list-html.svg": "QnwG",
	"./file-list-jar.svg": "C5vm",
	"./file-list-java.svg": "TJRk",
	"./file-list-json.svg": "M3CK",
	"./file-list-midi.svg": "t4ei",
	"./file-list-pdf.svg": "E5sH",
	"./file-list-php.svg": "Ak6f",
	"./file-list-picture.svg": "4Fln",
	"./file-list-ppt.svg": "s0KO",
	"./file-list-sql.svg": "prLD",
	"./file-list-swf-fill.svg": "nNNE",
	"./file-list-torrent.svg": "un7K",
	"./file-list-video.svg": "r8iq",
	"./file-list-xlsx.svg": "EzSA",
	"./file-new-built-folder.svg": "NYCM",
	"./file-share-save.svg": "BEyy",
	"./file-share-time.svg": "wNca",
	"./file-share.svg": "1djm",
	"./file-video.svg": "ST7c",
	"./file.svg": "fQ0v",
	"./logout.svg": "KvOj",
	"./setting.svg": "Kttn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 20